import { apiSlice } from '../../api';
import type {
  GetCountriesDTO,
  GetCountriesResult,
  UpdateCountryDTO,
  UpdateCountryResult,
} from './types';

export const adminCountriesEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      getCountries: build.query<GetCountriesResult, GetCountriesDTO>({
        query: (params) => {
          const args = params;
          return {
            url: '/admin/v1/countries',
            method: 'GET',
            params: args?.params,
          };
        },
        providesTags: ['Countries'],
      }),

      updateCountry: build.mutation<UpdateCountryResult, UpdateCountryDTO>({
        query: ({ alpha2code, body }) => ({
          url: `/admin/v1/countries/${alpha2code}`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['Countries'],
      }),
    };
  },
});

export const { useGetCountriesQuery } = adminCountriesEndpoints;
export const { useUpdateCountryMutation } = adminCountriesEndpoints;

export type AdminCountriesController = typeof adminCountriesEndpoints;
